'use client';

import { FC } from 'react';

import { useSelectedStore, useSliceItemsForSelectedStore } from '@/hooks';
import { pickLocationOrDefaultItem } from '@/utils/locationSlug';
import {
  BannerSlice,
  BannerSliceDefault,
  BannerSliceWithLogoOnBorder,
} from '@/types';

import DefaultVariation from './DefaultVariation';
import WithLogoOnBorderVariation from './WithLogoOnBorderVariation';

type BannerItem = BannerSlice['items'][number];

type BannerProps = BannerSlice & {
  alternateItems?: BannerItem[];
  initialStoreUrlSlug?: string;
};

const Banner: FC<BannerProps> = ({
  alternateItems,
  initialStoreUrlSlug,
  ...slice
}) => {
  const { store } = useSelectedStore();

  const filteredItems = useSliceItemsForSelectedStore({
    alternateItems,
    initialStoreUrlSlug,
    items: slice.items ?? [],
  });

  const banner = pickLocationOrDefaultItem(filteredItems);

  if (!slice?.primary?.active || !banner) {
    return null;
  }

  const resolvedSlice = { ...slice, items: [banner] } as BannerSlice;
  const storeKey = store?.url_slug ?? initialStoreUrlSlug ?? 'default';

  if (resolvedSlice.variation === 'withLogoOnBorder') {
    return (
      <WithLogoOnBorderVariation
        key={storeKey}
        {...(resolvedSlice as BannerSlice & BannerSliceWithLogoOnBorder)}
      />
    );
  }

  return (
    <DefaultVariation
      key={storeKey}
      {...(resolvedSlice as BannerSlice & BannerSliceDefault)}
    />
  );
};

export default Banner;
